import axios from "./request"

export default {
  async get(cep) {
    return (await axios.get('https://viacep.com.br/ws/' + cep + '/json/')).data
  }
}
